import { atomWithStorage } from "jotai/utils";
import { PAYMENT_CHANNEL_KEY, USER_STORAGE_KEY } from "./constants";

const defaultUser = localStorage.getItem(USER_STORAGE_KEY);
const defaultPaymentChannel = localStorage.getItem(PAYMENT_CHANNEL_KEY);

export const userAtom = atomWithStorage<UserData | undefined>(
  USER_STORAGE_KEY,
  JSON.parse(defaultUser!) ?? undefined,
);

// const pageIndex = localStorage.getItem("page-index") ?? '1';
export const pageIndexAtom = atomWithStorage<number>(
  "page-index",
  parseInt(localStorage.getItem("page-index") || "1"),
);

const profileImg = localStorage.getItem("profile-img");
export const profileImgAtom = atomWithStorage("profile-img", profileImg);

export const paymentChannelAtom = atomWithStorage<string | null>(
  PAYMENT_CHANNEL_KEY,
  defaultPaymentChannel?.replace(/"/g, "") || null,
);
